import { all, fork } from "redux-saga/effects";
import { profileSettingsSaga } from "./components/profile-settings/profile-settings-saga";
import { changePasswordSaga } from "./components/change-password/change-password-saga";

export function* profileSaga() {
  yield all([fork(profileSettingsSaga), fork(changePasswordSaga)]);
}
